module.exports = __webpack_public_path__ + "resources/dialog_celebrate_bg.9cff1095790e3644.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/dialog/img/dialog_celebrate_bg.png
// module id = 497
// module chunks = 0 1 2 3 4